import React, { FC } from "react";
import { LinkProps } from "theme-ui";
import { IconType } from "@kameleon-common/icons";
import { Variants } from "../..";
import { linkButtonDefaultProps } from "./link";

export const LinkButtonIcon: FC<LinkProps> = ({
  children,
  ...props
}: LinkProps) => (
  <Variants.Link variant="buttons.tertiary.text" {...props} as="a">
    {children}
    {/* TODO: Icon width for fa6-solid is larger than the others... */}
    <Variants.IconTertiary
      variant="buttons.tertiary.icon"
      icon={IconType.ChevronRight}
    />
  </Variants.Link>
);
LinkButtonIcon.defaultProps = linkButtonDefaultProps;
